import { useEffect, useState } from "react";
import { Smartphone, Share, PlusSquare } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

let deferred = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; });
}

const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export function InstallAppButton({ className = "" }) {
  const [installed, setInstalled] = useState(isStandalone);
  const [help, setHelp] = useState(false);
  useEffect(() => {
    const done = () => setInstalled(true);
    window.addEventListener("appinstalled", done);
    return () => window.removeEventListener("appinstalled", done);
  }, []);
  if (installed) return null;

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      const { outcome } = await deferred.userChoice;
      deferred = null;
      if (outcome === "accepted") setInstalled(true);
      return;
    }
    setHelp(true);
  };

  return (
    <>
      <button onClick={install} data-testid="install-app-button"
        className={`inline-flex items-center gap-2 px-6 h-12 rounded-full bg-emerald-700 text-white font-semibold hover:bg-emerald-800 transition-colors ${className}`}>
        <Smartphone className="w-5 h-5" /> Installer l'application
      </button>
      <Dialog open={help} onOpenChange={setHelp}>
        <DialogContent className="w-[calc(100%-2rem)] rounded-2xl" data-testid="install-app-help">
          <DialogHeader>
            <DialogTitle className="font-serif-display text-2xl font-normal">Passerelle sur votre écran d'accueil</DialogTitle>
            <DialogDescription>Une icône sur l'écran d'accueil, qui s'ouvre en plein écran, comme une application.</DialogDescription>
          </DialogHeader>
          {isIOS() ? (
            <ol className="space-y-3 text-gray-700">
              <li className="flex gap-3"><Share className="w-5 h-5 text-emerald-700 shrink-0 mt-0.5" /><span>Dans Safari, touchez le bouton <b>Partager</b>.</span></li>
              <li className="flex gap-3"><PlusSquare className="w-5 h-5 text-emerald-700 shrink-0 mt-0.5" /><span>Choisissez <b>Sur l'écran d'accueil</b>, puis <b>Ajouter</b>.</span></li>
            </ol>
          ) : (
            <ol className="space-y-3 text-gray-700">
              <li>1. Ouvrez le menu du navigateur (les <b>trois points</b> en haut à droite).</li>
              <li>2. Choisissez <b>Installer l'application</b> ou <b>Ajouter à l'écran d'accueil</b>.</li>
            </ol>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
